import React from "react";
import { PageHeader } from "@/components/site/PageHeader";
import { SiteFooter, FinalCTA } from "@/components/site/FinalCTA";
import TreeDemo from "@/components/site/TreeDemo";
import FeaturedTrees from "@/components/site/FeaturedTrees";
import GeographicBrowser from "@/components/site/GeographicBrowser";
import { PAGES } from "@/constants/testIds";

export default function FamilyTreesPage() {
  return (
    <div data-testid={PAGES.familyTrees} className="min-h-screen bg-ivory text-ink">
      <PageHeader
        eyebrow="India Family Trees"
        title="Every family, a"
        italic="branch"
        tail="on India's banyan."
        subtitle="Build your own tree, browse featured Indian family trees from the SocialPulse network, and step through generations from village to city to continent."
      />
      <TreeDemo />
      <FeaturedTrees />
      <GeographicBrowser />
      <FinalCTA onStart={() => window.scrollTo({ top: 0, behavior: "smooth" })} />
      <SiteFooter />
    </div>
  );
}
